/*
共有画像 (og:image と twitter:image) の配信元を、新しいドメインへ寄せる。

旧ドメイン storage.chotdekiru.com と storage.yumesaku.tech は同じ R2 バケット
(noiman) を指す。ファイル名は同じなので、ホストだけを置き換えればよい。

DB に入っている URL や本文の画像は書き換えない。共有画像として外へ出す
直前の1か所だけで直す。旧ドメインの URL を使う他の場所が残るため、
旧ドメイン側の配信は止めない。
*/

const LEGACY_STORAGE_ORIGIN = "https://storage.chotdekiru.com/";
const STORAGE_ORIGIN = "https://storage.yumesaku.tech/";

export function toCanonicalStorageUrl<T extends string | null | undefined>(
  url: T,
): T {
  if (typeof url === "string" && url.startsWith(LEGACY_STORAGE_ORIGIN)) {
    return (STORAGE_ORIGIN + url.slice(LEGACY_STORAGE_ORIGIN.length)) as T;
  }
  return url;
}
